import {
  Group,
  Select,
  Text,
  TextInput,
  Title,
  SimpleGrid,
  Paper,
  Stack,
  Divider,
} from "@mantine/core";
import { upperFirst } from "@mantine/hooks";
import React from "react";
import { countriesData } from "./data";

const renderFormField = (fieldName, form, required) => {
  return (
    <TextInput
      required={required}
      withAsterisk={required}
      label={fieldName.split("_").map(upperFirst).join(" ")}
      placeholder={fieldName.split("_").map(upperFirst).join(" ")}
      value={form.values[fieldName]}
      onChange={(event) =>
        form.setFieldValue(fieldName, event.currentTarget.value)
      }
      error={form.errors[fieldName]}
      size="md"
      radius="md"
      className="w-full"
    />
  );
};

export default function UserDetails({ form }) {
  return (
    <>
      <Title order={3} className="mb-1">
        Personal Information
      </Title>

      <Stack spacing="xl">
        {/* Section 1: Name */}
        <Paper radius="md" p="sm" >
          <Title order={5} mb="md">Basic Details</Title>
          <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: "md", cols: 1 }]}>
            {renderFormField("first_name", form, true)}
            {renderFormField("last_name", form, true)}
          </SimpleGrid>
        </Paper>
          <Divider/>
        {/* Section 2: Education / Job */}
        <Paper radius="md" p="sm" >
          <Title order={5} mb="md">
            {form.values.user_type === 3 ? "Education Details" : "Professional Details"}
          </Title>
          {form.values.user_type === 3 ? (
            <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: "md", cols: 1 }]}>
              {renderFormField("university", form, false)}
              {renderFormField("degree", form, false)}
            </SimpleGrid>
          ) : (
            <>
              <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: "md", cols: 1 }]}>
                {renderFormField("company", form, false)}
                {renderFormField("job_title", form, true)}
              </SimpleGrid>
              <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: "md", cols: 1 }]}>
                {renderFormField("year_of_experience", form, false)}
                {renderFormField("university", form, false)}
              </SimpleGrid>
            </>
          )}
        </Paper>
         <Divider/>
        {/* Section 3: Location */}
        <Paper radius="md" p="sm" >
          <Title order={5} mb="md">Location</Title>
          <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: "md", cols: 1 }]}>
            <Select
              required
              data={countriesData}
              label="Country"
              value={form.values.country}
              onChange={(event) => form.setFieldValue("country", event)}
              error={form.errors.country}
              radius="md"
              searchable
              size="md"
              nothingFound="No options"
              className="w-full"
            />
            {renderFormField("city", form, true)}
          </SimpleGrid>
        </Paper>
      </Stack>
    </>
  );
}
